export const WCL_REPORT_RETRIEVAL_THRESHOLD = 10
